import _findIndex from 'lodash/findIndex';
import _remove from 'lodash/remove';
import _sortedIndexBy from 'lodash/sortedIndexBy';
import _sortBy from 'lodash/sortBy';
import _toLower from 'lodash/toLower';
import get from 'lodash/get';

/**
 * @desc  GroupService class.
 * @ngInject
 */
export default class GroupService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   * @param {SchoolClassService} SchoolClassService
   */
  constructor(
    $rootScope, $q, $log, $http,
    SchoolClassService
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
    this.SchoolClassService = SchoolClassService;

    this.groups = [];
    this.students = [];

    this.$rootScope.$on('scr.select', () => {
      this.groups.splice(0, this.groups.length);
    });
  }

  addGroup(group) {
    const copyGroup = {};
    angular.copy(group, copyGroup);
    return this.$http({
      method: 'POST',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/group`,
      data: {group}
    }).then(result => {
      copyGroup.id = result.data.id;
      this.groups.splice(_sortedIndexBy(this.groups, copyGroup, item => _toLower(item.name)), 0, copyGroup);
      return copyGroup;
    }, err => this.$q.reject(err));
  }

  editGroup(group) {
    const copyGroup = {};
    angular.copy(group, copyGroup);
    return this.$http({
      method: 'PUT',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/group/${group.id}`,
      data: {group}
    }).then(result => {
      const id = _findIndex(this.groups, ['id', copyGroup.id]);
      this.groups.splice(id, 1, copyGroup);
      return result.data.id;
    }, err => this.$q.reject(err));
  }

  deleteGroup(groupId) {
    return this.$http({
      method: 'DELETE',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/group/${groupId}`
    }).then(() => {
      const index = _findIndex(this.groups, ['id', groupId]);
      this.groups.splice(index, 1);
      return groupId;
    }, err => this.$q.reject(err));
  }

  getAllGroups(fromServer = false) {
    if (this.groups.length > 0 && !fromServer) {
      return this.$q.resolve(this.groups);
    }

    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/group`
    }).then(result => {
      this.groups = _sortBy(result.data.groups, item => _toLower(item.name));
      return this.groups;
    }, err => this.$q.reject(err));
  }

  getStudents(groupId, fromServer = false) {
    if (this.students.length > 0 && !fromServer) {
      return this.$q.resolve(this.students);
    }

    return this.$http({
      method: 'GET',
      url: `/SCR/group/${groupId}/student`
    }).then(({data}) => {
      const {students} = data;
      return students.map(item => ({
        ...item,
        isDisabled: get(item, 'disabled', false),
        groupId: Number(get(item, 'groupId', -1))
      }));
    }, err => this.$q.reject(err));
  }

  addToGroup(groupId, studentsIds, date) {
    const student = {};
    const toDelete = new Set(studentsIds);
    student.userId = studentsIds;
    return this.$http({
      method: 'POST',
      url: `/SCR/group/${groupId}/student`,
      data: {student, date}
    }).then(result => {
      if (this.SchoolClassService.unassignedStudents.length > 0) {
        _remove(this.SchoolClassService.unassignedStudents, item => toDelete.has(item.userId));
      }

      return result.data;
    }, err => this.$q.reject(err));
  }

  deleteFromGroup(groupId, studentsIds) {
    const student = {};
    const toDelete = new Set(studentsIds);
    student.id = studentsIds;
    return this.$http({
      method: 'DELETE',
      url: `/SCR/group/${groupId}/student`,
      data: {student}
    }).then(() => {
      if (this.students.length > 0) {
        _remove(this.students, item => toDelete.has(item.id));
      }
    }, err => this.$q.reject(err));
  }
}
